import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=17adf0b0&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=ts"
export * from "./CustomCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=17adf0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17adf0b0",
  null
  
)

export default component.exports